/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_Last_TitleInputs */

const en_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to last event`)
};

const fr_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au dernier evenement`)
};

const de_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum letzten Ereignis gehen`)
};

const it_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'ultimo evento`)
};

const ru_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к последнему событию`)
};

const es_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al último evento`)
};

const zh_cn2_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往上一个活动`)
};

const ja_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のイベントへ移動`)
};

const hi_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम कार्यक्रम पर जाएं`)
};

const pt_pt2_video_export_preview_go_to_last_title = /** @type {(inputs: Video_Export_Preview_Go_To_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o último evento`)
};

/**
* | output |
* | --- |
* | "Go to last event" |
*
* @param {Video_Export_Preview_Go_To_Last_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_last_title = /** @type {((inputs?: Video_Export_Preview_Go_To_Last_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_Last_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_go_to_last_title(inputs)
	if (locale === "de") return de_video_export_preview_go_to_last_title(inputs)
	if (locale === "it") return it_video_export_preview_go_to_last_title(inputs)
	if (locale === "ru") return ru_video_export_preview_go_to_last_title(inputs)
	if (locale === "es") return es_video_export_preview_go_to_last_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_go_to_last_title(inputs)
	if (locale === "ja") return ja_video_export_preview_go_to_last_title(inputs)
	if (locale === "hi") return hi_video_export_preview_go_to_last_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_go_to_last_title(inputs)
	return en_video_export_preview_go_to_last_title(inputs)
});